import React, { useState, useEffect } from 'react';

import pdfImage from 'assets/images/pdf.png';
import folderImage from 'assets/images/folder.png';
import docImage from 'assets/images/doc.png';
import videoImage from 'assets/images/video.png';
import textImage from 'assets/images/text.png';
import xlsImage from 'assets/images/xls.png';
import fileImage from 'assets/images/file.png';
import { getDisplayableImageUrl, isHeicFile } from 'utils/heicUtils';

function Thumbnail({ item, selectFile }) {
  const [displayUrl, setDisplayUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadThumbnail = async () => {
      const fileType = returnFileType(getFileExtension(item.display_name));

      if (fileType === 'image' && item.url && isHeicFile(item.display_name)) {
        setIsLoading(true);
        try {
          const convertedUrl = await getDisplayableImageUrl(item.url, item.display_name);
          setDisplayUrl(convertedUrl);
        } catch (error) {
          console.error('Failed to convert HEIC thumbnail:', error);
          setDisplayUrl(item.url); // Fallback to original URL
        } finally {
          setIsLoading(false);
        }
      } else if (fileType === 'image') {
        setDisplayUrl(item.url);
      }
    };

    loadThumbnail();
  }, [item.url, item.display_name]);
  const returnFileType = (format) => {
    switch (format.toLowerCase()) {
      case 'pdf':
        return 'pdf';
      case 'docx':
      case 'doc':
        return 'doc';
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'heic':
      case 'heif':
        return 'image';
      case 'mp4':
      case 'avi':
      case 'mkv':
      case 'mov':
      case 'ogg':
        return 'video';
      case 'txt':
        return 'text';
      case 'xlsx':
      case 'xls':
        return 'xls';
      default:
        return 'folder';
    }
  };

  function getFileExtension(fileName) {
    if (fileName) {
      const lastIndex = fileName?.lastIndexOf('.');
      if (lastIndex === -1) {
        return '';
      } else {
        return fileName.substring(lastIndex + 1);
      }
    }
    return '';
  }

  const getThumbnailSrc = () => {
    if (item.entry_type === 'folder') {
      return folderImage;
    }

    const fileType = returnFileType(getFileExtension(item.display_name));

    switch (fileType) {
      case 'image':
        if (isLoading) {
          return fileImage; // Show generic icon while loading
        }
        return displayUrl || item.url;
      case 'doc':
        return docImage;
      case 'video':
        return videoImage;
      case 'pdf':
        return pdfImage;
      case 'text':
        return textImage;
      case 'xls':
        return xlsImage;
      default:
        return fileImage;
    }
  };

  return (
    <img
      src={getThumbnailSrc()}
      alt={item.isFolder ? 'Folder' : 'File'}
      style={{
        ...thumbnailStyles,
        ...(returnFileType(getFileExtension(item.display_name)) === 'image' ? { width: '100%', height: '75%', padding: '8px' } : {}),
      }}
      onClick={() => selectFile(item)}
    />
  );
}

export default Thumbnail;

const thumbnailStyles = {
  width: '64px',
  height: '64px',
  margin: 'auto',
  borderRadius: '16px 16px 0px 0px',
  objectFit: 'cover',
};
